import { createSlice } from '@reduxjs/toolkit';
import { resetApplication } from '../application/slice';
import activityLogsState from './state';
const activityLogsSlice = createSlice({
    extraReducers: builder => {
        builder.addCase(resetApplication, () => activityLogsState);
    },
    initialState: activityLogsState,
    name: 'activityLogs',
    reducers: {
        errorReceiveActivityCrossConnectionLogs: state => {
            state.requestingActivityCrossConnectionLogs = false;
        },
        errorReceiveActivityKEXLogs: state => {
            state.requestingActivityKEXLogs = false;
        },
        errorReceiveActivityLocationLogs: state => {
            state.requestingActivityLocationLogs = false;
        },
        errorReceiveActivityLocationNetworkInterfacesLogs: state => {
            state.requestingActivityLocationNetworkInterfacesLogs = false;
        },
        errorReceiveActivityLocationsLogs: state => {
            state.requestingActivityLocationsLogs = false;
        },
        errorReceiveActivityNetworkInterfacesLogs: state => {
            state.requestingActivityNetworkInterfacesLogs = false;
        },
        errorReceiveActivityUsersLogs: state => {
            state.requestingActivityUsersLogs = false;
        },
        failedReceiveActivityCrossConnectionLogs: state => {
            state.requestingActivityCrossConnectionLogs = false;
        },
        failedReceiveActivityKEXLogs: state => {
            state.requestingActivityKEXLogs = false;
        },
        failedReceiveActivityLocationLogs: state => {
            state.requestingActivityLocationLogs = false;
        },
        failedReceiveActivityLocationNetworkInterfacesLogs: state => {
            state.requestingActivityLocationNetworkInterfacesLogs = false;
        },
        failedReceiveActivityLocationsLogs: state => {
            state.requestingActivityLocationsLogs = false;
        },
        failedReceiveActivityNetworkInterfacesLogs: state => {
            state.requestingActivityNetworkInterfacesLogs = false;
        },
        failedReceiveActivityUsersLogs: state => {
            state.requestingActivityUsersLogs = false;
        },
        receiveActivityCrossConnectionLogs: {
            prepare: activityCrossConnectionLogs => {
                return {
                    payload: {
                        activityLogs: activityCrossConnectionLogs
                    }
                };
            },
            reducer: (state, action) => {
                const { activityLogs } = action.payload;
                state.activityCrossConnectionLogs.push(...activityLogs);
                state.receiveAllActivityLogs = false;
                state.requestingActivityCrossConnectionLogs = false;
            }
        },
        receiveActivityKEXLogs: {
            prepare: activityKEXLogs => {
                return {
                    payload: {
                        activityLogs: activityKEXLogs
                    }
                };
            },
            reducer: (state, action) => {
                const { activityLogs } = action.payload;
                state.activityKEXLogs.push(...activityLogs);
                state.receiveAllActivityLogs = false;
                state.requestingActivityKEXLogs = false;
            }
        },
        receiveActivityLocationLogs: {
            prepare: activityLocationLogs => {
                return {
                    payload: {
                        activityLogs: activityLocationLogs
                    }
                };
            },
            reducer: (state, action) => {
                const { activityLogs } = action.payload;
                state.activityLocationLogs.push(...activityLogs);
                state.receiveAllActivityLogs = false;
                state.requestingActivityLocationLogs = false;
            }
        },
        receiveActivityLocationNetworkInterfacesLogs: {
            prepare: activityLocationNetworkInterfacesLogs => {
                return {
                    payload: {
                        activityLogs: activityLocationNetworkInterfacesLogs
                    }
                };
            },
            reducer: (state, action) => {
                const { activityLogs } = action.payload;
                state.activityLocationNetworkInterfacesLogs.push(...activityLogs);
                state.receiveAllActivityLogs = false;
                state.requestingActivityLocationNetworkInterfacesLogs = false;
            }
        },
        receiveActivityLocationsLogs: {
            prepare: activityLocationsLogs => {
                return {
                    payload: {
                        activityLogs: activityLocationsLogs
                    }
                };
            },
            reducer: (state, action) => {
                const { activityLogs } = action.payload;
                state.activityLocationsLogs.push(...activityLogs);
                state.receiveAllActivityLogs = false;
                state.requestingActivityLocationsLogs = false;
            }
        },
        receiveActivityNetworkInterfacesLogs: {
            prepare: activityNetworkInterfacesLogs => {
                return {
                    payload: {
                        activityLogs: activityNetworkInterfacesLogs
                    }
                };
            },
            reducer: (state, action) => {
                const { activityLogs } = action.payload;
                state.activityNetworkInterfacesLogs.push(...activityLogs);
                state.receiveAllActivityLogs = false;
                state.requestingActivityNetworkInterfacesLogs = false;
            }
        },
        receiveActivityUsersLogs: {
            prepare: activityUsersLogs => {
                return {
                    payload: {
                        activityLogs: activityUsersLogs
                    }
                };
            },
            reducer: (state, action) => {
                const { activityLogs } = action.payload;
                state.activityUsersLogs.push(...activityLogs);
                state.receiveAllActivityLogs = false;
                state.requestingActivityUsersLogs = false;
            }
        },
        receiveAllActivityCrossConnectionLogs: {
            prepare: activityCrossConnectionLogs => {
                return {
                    payload: {
                        activityLogs: activityCrossConnectionLogs
                    }
                };
            },
            reducer: (state, action) => {
                const { activityLogs } = action.payload;
                state.activityCrossConnectionLogs.push(...activityLogs);
                state.receiveAllActivityLogs = true;
                state.requestingActivityCrossConnectionLogs = false;
            }
        },
        receiveAllActivityKEXLogs: {
            prepare: activityKEXLogs => {
                return {
                    payload: {
                        activityLogs: activityKEXLogs
                    }
                };
            },
            reducer: (state, action) => {
                const { activityLogs } = action.payload;
                state.activityKEXLogs.push(...activityLogs);
                state.receiveAllActivityLogs = true;
                state.requestingActivityKEXLogs = false;
            }
        },
        receiveAllActivityLocationLogs: {
            prepare: activityLocationLogs => {
                return {
                    payload: {
                        activityLogs: activityLocationLogs
                    }
                };
            },
            reducer: (state, action) => {
                const { activityLogs } = action.payload;
                state.activityLocationLogs.push(...activityLogs);
                state.receiveAllActivityLogs = true;
                state.requestingActivityLocationLogs = false;
            }
        },
        receiveAllActivityLocationNetworkInterfacesLogs: {
            prepare: activityLocationNetworkInterfacesLogs => {
                return {
                    payload: {
                        activityLogs: activityLocationNetworkInterfacesLogs
                    }
                };
            },
            reducer: (state, action) => {
                const { activityLogs } = action.payload;
                state.activityLocationNetworkInterfacesLogs.push(...activityLogs);
                state.receiveAllActivityLogs = true;
                state.requestingActivityLocationNetworkInterfacesLogs = false;
            }
        },
        receiveAllActivityLocationsLogs: {
            prepare: activityLocationsLogs => {
                return {
                    payload: {
                        activityLogs: activityLocationsLogs
                    }
                };
            },
            reducer: (state, action) => {
                const { activityLogs } = action.payload;
                state.activityLocationsLogs.push(...activityLogs);
                state.receiveAllActivityLogs = true;
                state.requestingActivityLocationsLogs = false;
            }
        },
        receiveAllActivityNetworkInterfacesLogs: {
            prepare: activityNetworkInterfacesLogs => {
                return {
                    payload: {
                        activityLogs: activityNetworkInterfacesLogs
                    }
                };
            },
            reducer: (state, action) => {
                const { activityLogs } = action.payload;
                state.activityNetworkInterfacesLogs.push(...activityLogs);
                state.receiveAllActivityLogs = true;
                state.requestingActivityNetworkInterfacesLogs = false;
            }
        },
        receiveAllActivityUsersLogs: {
            prepare: activityUsersLogs => {
                return {
                    payload: {
                        activityLogs: activityUsersLogs
                    }
                };
            },
            reducer: (state, action) => {
                const { activityLogs } = action.payload;
                state.activityUsersLogs.push(...activityLogs);
                state.receiveAllActivityLogs = true;
                state.requestingActivityUsersLogs = false;
            }
        },
        requestActivityCrossConnectionLogs: {
            prepare: (page, status, filter) => {
                return {
                    payload: {
                        filter,
                        page,
                        status
                    }
                };
            },
            reducer: (state, action) => {
                state.page = action.payload.page;
                state.requestingActivityCrossConnectionLogs = true;
            }
        },
        requestActivityKEXLogs: {
            prepare: (page, status, filter) => {
                return {
                    payload: {
                        filter,
                        page,
                        status
                    }
                };
            },
            reducer: (state, action) => {
                state.page = action.payload.page;
                state.requestingActivityKEXLogs = true;
            }
        },
        requestActivityLocationLogs: {
            prepare: (page, status, location, filter) => {
                return {
                    payload: {
                        filter,
                        location,
                        page,
                        status
                    }
                };
            },
            reducer: (state, action) => {
                state.page = action.payload.page;
                state.requestingActivityLocationLogs = true;
            }
        },
        requestActivityLocationNetworkInterfacesLogs: {
            prepare: (page, status, filter) => {
                return {
                    payload: {
                        filter,
                        page,
                        status
                    }
                };
            },
            reducer: (state, action) => {
                state.page = action.payload.page;
                state.requestingActivityLocationNetworkInterfacesLogs = true;
            }
        },
        requestActivityLocationsLogs: {
            prepare: (page, status, filter) => {
                return {
                    payload: {
                        filter,
                        page,
                        status
                    }
                };
            },
            reducer: (state, action) => {
                state.page = action.payload.page;
                state.requestingActivityLocationsLogs = true;
            }
        },
        requestActivityNetworkInterfacesLogs: {
            prepare: (page, status, filter) => {
                return {
                    payload: {
                        filter,
                        page,
                        status
                    }
                };
            },
            reducer: (state, action) => {
                state.page = action.payload.page;
                state.requestingActivityNetworkInterfacesLogs = true;
            }
        },
        requestActivityUsersLogs: {
            prepare: (page, status, filter) => {
                return {
                    payload: {
                        filter,
                        page,
                        status
                    }
                };
            },
            reducer: (state, action) => {
                state.page = action.payload.page;
                state.requestingActivityUsersLogs = true;
            }
        },
        resetActivityCrossConnectionLogs: state => {
            state.activityCrossConnectionLogs = [];
            state.page = undefined;
            state.receiveAllActivityLogs = false;
            state.requestingActivityCrossConnectionLogs = false;
        },
        resetActivityKEXLogs: state => {
            state.activityKEXLogs = [];
            state.page = undefined;
            state.receiveAllActivityLogs = false;
            state.requestingActivityKEXLogs = false;
        },
        resetActivityLocationLogs: state => {
            state.activityLocationLogs = [];
            state.page = undefined;
            state.receiveAllActivityLogs = false;
            state.requestingActivityLocationLogs = false;
        },
        resetActivityLocationNetworkInterfacesLogs: state => {
            state.activityLocationNetworkInterfacesLogs = [];
            state.page = undefined;
            state.receiveAllActivityLogs = false;
            state.requestingActivityLocationNetworkInterfacesLogs = false;
        },
        resetActivityLocationsLogs: state => {
            state.activityLocationsLogs = [];
            state.page = undefined;
            state.receiveAllActivityLogs = false;
            state.requestingActivityLocationsLogs = false;
        },
        resetActivityLogs: () => activityLogsState,
        resetActivityNetworkInterfacesLogs: state => {
            state.activityNetworkInterfacesLogs = [];
            state.page = undefined;
            state.receiveAllActivityLogs = false;
            state.requestingActivityNetworkInterfacesLogs = false;
        },
        resetActivityUsersLogs: state => {
            state.activityUsersLogs = [];
            state.page = undefined;
            state.receiveAllActivityLogs = false;
            state.requestingActivityUsersLogs = false;
        }
    }
});
export const { errorReceiveActivityCrossConnectionLogs, errorReceiveActivityKEXLogs, errorReceiveActivityLocationLogs, errorReceiveActivityLocationNetworkInterfacesLogs, errorReceiveActivityLocationsLogs, errorReceiveActivityNetworkInterfacesLogs, errorReceiveActivityUsersLogs, failedReceiveActivityCrossConnectionLogs, failedReceiveActivityKEXLogs, failedReceiveActivityLocationLogs, failedReceiveActivityLocationNetworkInterfacesLogs, failedReceiveActivityLocationsLogs, failedReceiveActivityNetworkInterfacesLogs, failedReceiveActivityUsersLogs, receiveActivityCrossConnectionLogs, receiveActivityKEXLogs, receiveActivityLocationLogs, receiveActivityLocationNetworkInterfacesLogs, receiveActivityLocationsLogs, receiveActivityNetworkInterfacesLogs, receiveActivityUsersLogs, receiveAllActivityCrossConnectionLogs, receiveAllActivityKEXLogs, receiveAllActivityLocationLogs, receiveAllActivityLocationNetworkInterfacesLogs, receiveAllActivityLocationsLogs, receiveAllActivityNetworkInterfacesLogs, receiveAllActivityUsersLogs, requestActivityCrossConnectionLogs, requestActivityKEXLogs, requestActivityLocationLogs, requestActivityLocationNetworkInterfacesLogs, requestActivityLocationsLogs, requestActivityNetworkInterfacesLogs, requestActivityUsersLogs, resetActivityCrossConnectionLogs, resetActivityKEXLogs, resetActivityLocationLogs, resetActivityLocationNetworkInterfacesLogs, resetActivityLocationsLogs, resetActivityLogs, resetActivityNetworkInterfacesLogs, resetActivityUsersLogs } = activityLogsSlice.actions;
export default activityLogsSlice.reducer;
